export const environment = {
  production: true,
  apiUrl: "https://revolution00.site/api_umyocards/public/api/"
};


